import React from 'react'
import { Spinner } from 'src/Throbber/Spinner'
import CircleCheckFillSVGPath from 'src/components/Icons/Basic/icons_circle_check_fill.svg'
import palette from 'src/designSystem/variables/palette'
import { STATUS_TYPES, PROGRESS_STATUS } from './StatusIndicator.constants'
import {
  StatusIndicatorBar,
  StatusIndicatorCircle,
} from './StatusIndicator.styles'

type StatusIndicatorProps = {
  statusType: STATUS_TYPES
  status: number
}

export const StatusIndicator = ({
  statusType,
  status,
}: StatusIndicatorProps): JSX.Element => (
  <StatusIndicatorBar statusType={statusType} status={status} />
)

export const StatusCircleIndicator = ({
  status,
}: {
  status: PROGRESS_STATUS
}): JSX.Element => {
  let indicator: JSX.Element
  switch (status) {
    case PROGRESS_STATUS.PENDING:
      indicator = (
        <StatusIndicatorCircle
          backgroundColor={palette.neutral['white']}
          borderColor={palette.neutral[100]}
        />
      )
      break
    case PROGRESS_STATUS.INPROGRESS:
      indicator = <Spinner size="s" color="secondary" />
      break
    case PROGRESS_STATUS.SUCCESS:
      indicator = <img src={CircleCheckFillSVGPath} alt="Success" />
      break
    case PROGRESS_STATUS.FAILED:
      indicator = <span>✗</span>
      break
    default:
      indicator = <span>?</span>
  }
  return indicator
}
